/**
 *    @author:
 *    @since:
 *
 */

import { IValidator } from '../_common/component/IValidator';
import { SINAreYouSureComponent} from './SIN_are_you_sure.component';

export class SINAreYouSureValidation extends IValidator {

       constructor(private component: SINAreYouSureComponent) {
             super();
       }

       private success: boolean;

       public validate(): boolean {

            this.success = true;

            // add your valdation here!

            return this.success;

       }
}

